import React from 'react';

import { GenerateListIcon } from './GenerateListIcon';
import { ListIconsProps } from './types';

const defaultTooltipMessageKey = 'layout.action.delete';

export const DeleteIcon: React.FC<ListIconsProps> = ({
  enabled,
  onClick,
  tooltipMessageKey = defaultTooltipMessageKey,
  ...rest
}) =>
  enabled ? (
    <GenerateListIcon
      {...rest}
      onClick={onClick}
      tooltipMessageKey={tooltipMessageKey}
      kind="bin"
      additionalClassName="delete"
    />
  ) : (
    <GenerateListIcon
      {...rest}
      kind="bin"
      additionalClassName="delete-disabled"
      tooltipMessageKey={tooltipMessageKey !== defaultTooltipMessageKey ? tooltipMessageKey : undefined}
    />
  );
